import { mapRedirects } from '@/utils/constants'

export default function ({ route, redirect, app }) {
  const pageQuery = route?.query?._a

  if (pageQuery) {
    // Check if the _a parameter contains encoded query parameters (e.g., cart?couponCode=ABC)
    const decodedQuery = decodeURIComponent(pageQuery)
    const [action, queryString] = decodedQuery.split('?')

    if (Object.prototype.hasOwnProperty.call(mapRedirects, action)) {
      const mapped = mapRedirects[action]
      const query = Object.assign({}, route.query)

      // Parse additional query parameters from the _a value
      if (queryString) {
        const params = new URLSearchParams(queryString)
        for (const [key, value] of params) {
          query[key] = value
        }
      }

      if (mapped.clearAction) {
        delete query._a
      }

      redirect({ name: `${app.i18n.locale}/${mapped.redirect}`, query })
    }
  }
}
